/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { QueueJob } from './QueueJob';
import {
    QueueJobFromJSON,
    QueueJobFromJSONTyped,
    QueueJobToJSON,
    QueueJobToJSONTyped,
} from './QueueJob';

/**
 * 
 * @export
 * @interface QueueReport
 */
export interface QueueReport  {
    /**
     * 
     * @type {QueueJob}
     * @memberof QueueReport
     */
    queueJob?: QueueJob;
    /**
     * 
     * @type {string}
     * @memberof QueueReport
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueReport
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the QueueReport interface.
 */
export function instanceOfQueueReport(value: object): value is QueueReport {
    return true;
}

export function QueueReportFromJSON(json: any): QueueReport {
    return QueueReportFromJSONTyped(json, false);
}

export function QueueReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueueReport {
    if (json == null) {
        return json;
    }
    return {
        
                  'queueJob': json['queueJob'] == null ? undefined : QueueJobFromJSON(json['queueJob']),
                  'status': json['status'] == null ? undefined : json['status'],
                  'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function QueueReportToJSON(json: any): QueueReport {
    return QueueReportToJSONTyped(json, false);
}

export function QueueReportToJSONTyped(value?: QueueReport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'queueJob': QueueJobToJSON(value['queueJob']),
        'status': value['status'],
        'errorMessage': value['errorMessage'],
    };
}


